export default __webpack_public_path__ + "static/media/Snd_LowerWSlideupa.220429e7.mp3";